// extracted by mini-css-extract-plugin
export default {"loader":"Spinner_loader__L4eii","spin":"Spinner_spin__5LRrf","container":"Spinner_container__oq2eC"};